var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Picmap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-pic_map",
    "data-name": "icon-24-pic map",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7100",
    "data-name": "Rectangle 7100",
    width: 28,
    height: 28,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Expanded",
    transform: "translate(-1.777 2.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555",
    transform: "translate(8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M15.778,23.216l-.4-.579C15.077,22.2,8,11.909,8,7.778a7.778,7.778,0,0,1,15.555,0c0,4.131-7.077,14.423-7.378,14.859Zm0-22.244A6.813,6.813,0,0,0,8.972,7.778c0,3.3,5.291,11.45,6.805,13.715,1.514-2.265,6.805-10.416,6.805-13.715A6.813,6.813,0,0,0,15.778.972Z",
    transform: "translate(-8)",
    fill: "#1dbbbe",
    stroke: "#1dbbbe",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554",
    transform: "translate(4.375 4.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M20.4,15.805a3.4,3.4,0,1,1,3.4-3.4A3.407,3.407,0,0,1,20.4,15.805Zm0-5.833A2.431,2.431,0,1,0,22.833,12.4,2.433,2.433,0,0,0,20.4,9.972Z",
    transform: "translate(-17 -9)",
    fill: "#1dbbbe",
    stroke: "#1dbbbe",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Picmap);
export default __webpack_public_path__ + "static/media/icon-24-pic map.645ab3008a6bcff18b8b4472ce09e9a9.svg";
export { ForwardRef as ReactComponent };